import { render, staticRenderFns } from "./ApprovalPetitionDetails_new.vue?vue&type=template&id=5b9dd81f"
import script from "./ApprovalPetitionDetails_new.vue?vue&type=script&lang=js"
export * from "./ApprovalPetitionDetails_new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports